import { render } from "./Mb063.vue?vue&type=template&id=6635371b&scoped=true"
import script from "./Mb063.vue?vue&type=script&lang=js"
export * from "./Mb063.vue?vue&type=script&lang=js"

import "./Mb063.vue?vue&type=style&index=0&id=6635371b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6635371b"]])

export default __exports__